<template>
  <div class="bespread-wrap module-layer1">
    <div class="screen-container">
      <div class="kv-content">
        <img src="../../assets/img/layer1/bi.png" alt="" srcset="" class="bi" />
        <div class="kv-btn cursor">
          <img
            class="ly-icon gg-pad cursor"
            src="../../assets/img/layer1/gg.png"
            @click="handlegLyGP('gp')"
          />
          <img
            class="ly-icon cursor"
            src="../../assets/img/layer1/as.png"
            @click="handlegLyIOS('ios')"
          />
           <img
            class="ly-icon cursor"
            src="../../assets/img/layer1/os.png"
            @click="handlegLyOS('os')"
          />
      
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "app",

  data() {
    return {};
  },
  watch: {},
  created() {},
  methods: {
    // 点击按钮跳转
    handlegLyGP(val) {
      this.common.goShare(val);
    },
    handlegLyIOS(val) {
      this.common.goShare(val);
    },
    handlegLyOS(val) {
      this.common.goShare(val);
    }
  }
};
</script>
<style lang="scss" scoped>
.module-layer1 {
  // pointer-events: none;
  background-image: url("../../assets/img/layer1/bg.png ");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  .screen-container {
    width: 100%;
    .kv-content {
      position: absolute;
      bottom: 10vw;
      left: 44%;

      transform: translate(-50%, 0);
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      z-index: 1;
      gap: 2.5vw;
      .bi {
        width: auto;
        height: 565px;
      }
      .kv-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 2vw;
        .ly-icon {
          width: 160px;
          height: auto;
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .module-layer1 {
    .kv-content {
      bottom: 12vw !important;
    }
  }
}

@media screen and (min-width: 2000px) and (max-width: 2561px) {
  .module-layer1 {
    .kv-content {
      // bottom: 3vw !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/layer1.vue